import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeldingFixtureSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #05b5ce;\n      }\n\n      .cls-2 {\n        fill: #9d9d9d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        opacity: .66;\n      }\n    " }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-white",
				points: "19.22 12.92 19.22 12.5 17.41 11.45 17.41 11.87 14.3 10.08 14.3 9.66 12.49 8.62 10.68 9.66 10.68 10.08 7.71 11.79 7.71 11.45 5.9 12.5 5.9 12.84 3.54 14.2 3.54 15.14 12.55 20.34 21.5 15.17 21.5 14.23 19.22 12.92"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M11.76,6.3l-.54.31.62-.05s.02,0,.03,0c.1,0,.19.04.25.11.07.07.1.16.1.25v.62s.26-.56.26-.56c.06-.13.19-.21.32-.21.06,0,.13.02.18.05l.53.31-.36-.51c-.06-.08-.08-.19-.06-.28.02-.1.08-.18.17-.23l.54-.31-.62.05s-.02,0-.03,0c-.1,0-.19-.04-.25-.11-.07-.07-.1-.16-.1-.25v-.62s-.26.56-.26.56c-.06.13-.19.21-.32.21-.06,0-.13-.02-.18-.05l-.53-.31.36.51c.06.08.08.18.06.28-.02.1-.08.18-.17.23Z"
			}),
			/* @__PURE__ */ _jsx("line", {
				className: "icon-white",
				x1: 12.55,
				y1: 19.4,
				x2: 12.55,
				y2: 20.34
			})
		] }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M21.75,14.22s0-.04-.01-.06c0-.02-.01-.03-.03-.06,0-.01-.02-.02-.04-.05-.01-.01-.03-.02-.04-.03l-2.17-1.25v-.27c0-.07-.03-.13-.07-.18-.02-.02-.03-.03-.05-.04l-1.81-1.04c-.08-.05-.18-.05-.26,0-.07.04-.12.12-.13.2l-2.6-1.5v-.27c0-.09-.05-.18-.13-.22l-1.81-1.04c-.08-.05-.18-.05-.26,0l-1.81,1.04c-.08.05-.13.13-.13.22v.27l-2.48,1.43c-.02-.05-.06-.1-.11-.13-.08-.05-.18-.05-.26,0l-1.81,1.04s-.04.02-.05.04c-.05.05-.07.11-.07.18v.19l-2.24,1.29s-.04.03-.06.05c-.01.01-.02.03-.04.05-.02.04-.03.08-.03.12v.94c0,.09.05.18.13.22l9.01,5.2s.03.01.06.02c.01,0,.03,0,.06,0,.02,0,.04,0,.08-.01.02,0,.03-.01.05-.02l8.95-5.17c.08-.04.13-.13.13-.22v-.95ZM17.66,11.89l1.04.6-.83.48-.21-.12v-.96ZM17.66,13.69l1.3-.75v.96l-1.3.75v-.96ZM12.75,9.06l1.3.75v.96l-1.3-.75v-.96ZM10.94,9.81l1.3-.75v.96l-1.3.75v-.96ZM7.45,11.89v.96l-.21.12-.83-.48,1.04-.6ZM6.16,12.94l1.3.75v.96l-1.3-.75v-.96ZM12.29,19.89L3.79,14.99v-.35l8.5,4.91v.34ZM12.55,19.11l-8.5-4.91,1.6-.92v.77s.01.09.03.13c.02.04.05.07.09.09l1.81,1.04c.08.04.18.04.26,0,.08-.05.13-.13.13-.22v-1.55c0-.09-.05-.18-.13-.22l-.08-.04.08-.04c.08-.05.13-.13.13-.22v-1.07l2.46-1.42v.7c0,.09.05.18.13.22.08.04.18.04.26,0l1.68-.97,1.68.97c.08.04.18.04.26,0,.08-.05.13-.13.13-.22v-.69l2.6,1.5v.99c0,.09.05.18.13.22l.08.04-.08.04c-.08.05-.13.13-.13.22v1.55c0,.09.05.18.13.22.08.04.18.04.26,0l1.81-1.04s.07-.06.09-.09c.02-.04.03-.08.03-.13v-.69l1.51.87-8.44,4.87ZM21.24,15.02l-8.44,4.87v-.34l8.44-4.87v.35Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M10.37,7.9s.09-.01.13-.04l.22-.14c.12-.07.16-.23.08-.35-.04-.06-.09-.1-.16-.11-.07-.02-.14,0-.19.03l-.22.14c-.06.04-.1.09-.11.16s0,.14.03.19c.05.08.13.12.22.12Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M6.85,10.07s.09-.01.13-.04l.45-.28c.06-.04.1-.09.12-.16.02-.07,0-.14-.03-.19-.07-.12-.23-.16-.35-.08l-.45.28c-.12.07-.16.23-.08.35.05.08.13.12.22.12Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M9.19,8.62s.09-.01.13-.04l.45-.28c.12-.07.16-.23.08-.35s-.23-.16-.35-.08l-.45.28c-.06.04-.1.09-.11.16-.02.07,0,.14.03.19.05.08.13.12.22.12Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M8.02,9.34s.09-.01.13-.04l.45-.28c.12-.07.16-.23.08-.35-.07-.12-.23-.16-.35-.08l-.45.28c-.12.07-.16.23-.08.35.05.08.13.12.22.12Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M5.9,10.65s.09-.01.13-.04l.22-.14c.12-.07.16-.23.08-.35-.04-.06-.09-.1-.16-.11s-.14,0-.19.03l-.22.14c-.12.07-.16.23-.08.35.05.08.13.12.22.12Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M14.62,7.86s.09.04.13.04c.09,0,.17-.05.22-.12.04-.06.05-.13.03-.19-.02-.07-.06-.12-.11-.16l-.22-.14c-.12-.07-.28-.04-.35.08-.07.12-.04.28.08.35l.22.14Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M18.14,10.03s.09.04.13.04c.09,0,.17-.05.22-.12.07-.12.04-.28-.08-.35l-.45-.28c-.06-.04-.13-.05-.19-.03-.07.02-.12.06-.16.11-.07.12-.04.28.08.35l.45.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M15.79,8.58s.09.04.13.04c.09,0,.17-.05.22-.12.04-.06.05-.13.03-.19s-.06-.12-.12-.16l-.45-.28c-.12-.07-.28-.04-.35.08-.07.12-.04.28.08.35l.45.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M16.97,9.3s.09.04.13.04c.09,0,.17-.05.22-.12.07-.12.04-.28-.08-.35l-.45-.28c-.12-.07-.28-.04-.35.08-.07.12-.04.28.08.35l.45.28Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M19.08,10.61s.09.04.13.04c.09,0,.17-.05.22-.12.07-.12.04-.28-.08-.35l-.22-.14c-.06-.04-.13-.05-.19-.03s-.12.06-.16.11c-.07.12-.04.28.08.35l.22.14Z"
			})
		] }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M12.83,12.33l-.22.13s-.08.03-.12.03-.08,0-.12-.03l-.22-.13c-.11-.07-.15-.21-.08-.32.06-.11.2-.15.31-.08l.11.06.11-.06c.11-.07.25-.03.32.08.06.11.02.25-.09.32Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M11.95,11.94c-.04.07-.12.12-.2.12-.04,0-.08,0-.12-.03l-.32-.19c-.05-.03-.09-.08-.11-.14-.01-.06-.01-.12.02-.17.07-.11.21-.15.32-.09l.32.19c.11.06.15.2.09.31Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M13.67,11.85l-.33.18s-.07.03-.11.03c-.08,0-.16-.04-.2-.11-.03-.06-.04-.12-.02-.18.01-.06.05-.11.1-.14l.32-.18c.06-.04.12-.04.18-.03.06.02.11.06.14.11.06.11.02.25-.08.32Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M11.11,11.46c-.04.07-.12.11-.2.11-.04,0-.08-.01-.12-.03l-.11-.07s.09,0,.13-.04l.31-.18c.03.06.03.14-.01.21Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M14.3,11.47l-.12.08s-.08.03-.12.03c-.08,0-.16-.04-.2-.11-.04-.07-.04-.15,0-.22l.32.18s.09.04.13.04Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M8.96,13.74c-.04.07-.11.12-.2.12-.04,0-.08-.01-.11-.03l-.32-.19c-.06-.03-.1-.08-.11-.14-.02-.06-.01-.12.02-.18.07-.11.21-.14.32-.08l.32.19c.11.06.15.2.08.31Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M9.74,14.05c0,.09-.05.16-.12.2l-.22.13s-.08.04-.12.04c-.08,0-.16-.05-.2-.12-.04-.08-.04-.17,0-.25-.05-.07-.05-.16,0-.24.07-.11.21-.15.32-.09l.22.13c.07.05.12.12.12.2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M8.88,14.68l-.32.19s-.07.03-.11.03c-.08,0-.16-.05-.2-.12-.03-.05-.04-.11-.03-.17.02-.06.06-.11.11-.14l.32-.19c.11-.06.25-.02.32.08.06.12.02.26-.09.32Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M8.12,13.26c-.04.07-.11.11-.2.11,0,0-.03,0-.04,0,0-.02-.02-.03-.04-.04l-.08-.05.08-.04c.08-.05.13-.13.13-.23v-.1l.07.04c.11.06.15.21.08.32Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M16.89,14.6c0,.06,0,.13-.02.18-.05.07-.12.11-.2.11-.04,0-.08,0-.12-.03l-.32-.18c-.11-.07-.15-.21-.09-.32.03-.05.08-.09.14-.11.06-.01.12,0,.18.03l.32.18s.09.08.11.14Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M16.02,14.05c.04.07.05.17.01.24-.05.07-.12.12-.2.12-.05,0-.08,0-.12-.03l-.23-.13c-.07-.04-.11-.12-.11-.2s.04-.16.11-.2l.23-.13c.11-.07.25-.03.32.08.04.08.03.18-.01.25Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M16.88,13.5c0,.06-.05.11-.11.14l-.32.18s-.07.03-.11.03c-.08,0-.16-.04-.2-.11-.07-.11-.03-.25.08-.32l.32-.18c.06-.03.12-.04.18-.03.06.02.11.06.14.11.03.05.04.12.02.18Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M17.36,13.27l-.08.05s-.02.01-.03.03c-.03.02-.05.02-.08.02-.08,0-.16-.04-.2-.11-.06-.11-.02-.26.09-.32l.09-.05v.11c0,.1.05.18.13.23l.08.04Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M14.2,5.9c.09-.05.13-.15.1-.25-.02-.1-.11-.17-.21-.17l-.92.08s-.04,0-.05-.02c-.02-.01-.02-.03-.02-.05v-.9c0-.06-.02-.11-.06-.15-.04-.05-.1-.07-.16-.07-.09,0-.17.05-.2.13l-.38.81s-.07.05-.1.03l-.78-.45c-.11-.06-.25-.02-.31.09-.04.08-.03.16.02.23l.51.73s.02.04,0,.06c0,.02,0,.04-.03.05l-.78.44c-.09.05-.13.15-.11.25.03.1.12.17.22.17l.92-.08s.04,0,.05.02c.01.01.02.03.02.05v.9c0,.06.02.11.06.16.04.04.1.06.16.06.09,0,.16-.05.2-.13l.38-.81s.06-.05.1-.03l.77.45c.11.07.26.02.32-.09.03-.07.03-.16-.02-.23l-.51-.73s-.02-.04-.02-.06c.01-.02.02-.04.04-.05l.78-.44ZM12.83,6.27c-.01.06-.02.13-.01.2-.14,0-.28.04-.39.13-.03-.06-.07-.1-.11-.15-.05-.06-.12-.1-.19-.13.03-.06.06-.13.08-.19.01-.07.02-.14.01-.21.14,0,.28-.04.39-.12.03.05.06.1.11.14.05.06.12.1.19.13-.04.06-.06.13-.08.2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M11.15,6.14c.11,0,.2-.08.23-.18.03-.12-.05-.25-.18-.27l-.7-.15c-.06-.01-.12,0-.17.03-.05.03-.09.08-.1.15-.03.12.05.25.18.27l.71.15s.03,0,.05,0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M14.64,6.41l-.7-.15c-.12-.02-.25.05-.27.18-.01.06,0,.12.03.17s.09.09.15.1l.7.15s.03,0,.05,0c.11,0,.2-.08.23-.18.01-.06,0-.12-.03-.17-.03-.05-.08-.09-.15-.1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M13.17,8.44s.05,0,.07-.01c.06-.02.11-.06.13-.11.03-.06.03-.12.01-.18l-.22-.68c-.04-.12-.17-.19-.29-.15-.06.02-.11.06-.13.11-.03.06-.03.12-.01.18l.22.68c.03.1.12.16.22.16Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M12.09,5.1s.05,0,.07-.01c.12-.04.19-.17.15-.29l-.22-.68c-.02-.06-.06-.11-.11-.13s-.12-.03-.18-.01c-.06.02-.11.06-.13.11-.03.06-.03.12-.01.18l.22.68c.03.1.12.16.22.16Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M13.45,5.39c.07,0,.13-.03.17-.08l.48-.54s.06-.1.06-.17c0-.06-.03-.12-.08-.16-.09-.08-.24-.08-.33.02l-.48.54c-.09.09-.08.24.02.33.04.04.1.06.15.06Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M11.27,7.92l.48-.53c.09-.09.08-.24-.02-.33-.05-.04-.1-.06-.17-.06-.06,0-.12.03-.16.08l-.48.53c-.09.09-.08.24.02.33.04.04.1.06.15.06.07,0,.13-.03.17-.08Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M8.16,15.02c-.02.06-.06.11-.11.14l-.11.06s.03-.08.03-.13v-.35c.07,0,.13.04.17.11.03.05.03.11.02.17Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M17.18,15.22l-.11-.06c-.11-.06-.15-.2-.09-.31.04-.07.1-.11.17-.11v.35s.01.09.03.13Z"
			})
		] }) })
	]
});
export default SvgWeldingFixtureSm;
